import type { Release } from '../releases';

export default {
  id: '2026-11-03-kb-publish-permissions',
  at: '2026-11-03T17:40:42Z',
  title: 'База знаний: права издателя отделены от редактирования',
  modules: ['kb'],
  items: [
    'Издатель видит версию статьи на проверке и может опубликовать её или вернуть автору.',
    'Редактирование чужой статьи, смена владельца, архив и импорт требуют соответствующих полномочий: одного права публикации для них недостаточно.',
    'Проверка статьи из «Ждёт меня» открывается с теми же правами, что и её карточка.',
  ],
  why: 'Право публикации давало лишние возможности: проверяющий мог менять содержание и владельца чужой статьи.',
  link: '/kb',
} satisfies Release;
